import { render, staticRenderFns } from "./PopupAddTask.vue?vue&type=template&id=b3c4f0aa"
import script from "./PopupAddTask.vue?vue&type=script&lang=ts"
export * from "./PopupAddTask.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports